var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.width > 1050)?_c('header-component'):_c('hamburger-component'),_c('main-component'),_c('commitment-component'),_c('human-resource-component'),_c('contact-component'),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }